import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { FaRegEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import { warningSwal, successSwal, Success } from "Util/Toast";
import SkeletonLoad from "Components/TableLoad/load";
import CommonClasses from "Styles/Common.module.css";
import { Helmet } from "react-helmet";
import Layout from "Components/Layout";
import { BiPlus } from "react-icons/bi";
import { TablePagination } from "@mui/material";

function TemplateCategories() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const fetchTemplates = () => {
        setLoading(true);
        Services.getTemplateCategories("POST", null, token)
            .then((response) => {
                setLoading(false);
                if (response.Status === 1) {
                    setData(response.TemplateCategories);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("Something went wrong. Please try again.");
                console.error(err);
            });
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleDelete = (templateCategoryId, templateCategoryName) => {
        if (window.confirm(`Are you sure you want to delete "${templateCategoryName}"?`)) {
            setLoading(true);
            Services.deleteTemplateCategory(templateCategoryId, token)
                .then((response) => {
                    setLoading(false);
                    if (response.Status === 1) {
                        Success("Success", "Template Category deleted successfully!");
                        fetchTemplates(); // Refresh the list
                    } else if (response.Status === 0) {
                        warningSwal("Warning", response.Message);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    alert("Something went wrong. Please try again.");
                    console.error(err);
                });
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Layout Active={"TemplateCategories"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>TemplateCategories</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div>
                    <h1 style={{ color: '#FF0D0D' }}>TEMPLATE CATEGORIES</h1>
                </div>
                <div className={CommonClasses["control-btns"]}>
                    <button
                        className={CommonClasses["button"]}
                        onClick={() => {
                            navigate("/addtemplatecategory");
                        }}
                    >
                        <BiPlus size={20} /> Create New Template Category
                    </button>
                </div>
                <div className={CommonClasses["wrapper"]}>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "TemplateCategoryImage",
                                "CategoryName",
                                "CreatedAt",
                                "UpdatedAt",
                                "Status",
                                "Actions",
                            ]}
                        />
                    ) : data.length > 0 ? (
                        <div className={CommonClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Template Category Image</th>
                                        <th>CategoryName</th>
                                        <th>CreatedAt</th>
                                        <th>UpdatedAt</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        .map((item) => (
                                            <tr
                                                key={item.TemplateCategoryId}
                                                id={item.TemplateCategoryId}
                                                name={item.TemplateCategoryName}
                                                // onClick={() =>
                                                //     navigate(
                                                //         `/bannerdetails/${item.TemplateCategoryId}`
                                                //     )
                                                // }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td>
                                                    <img
                                                        style={{
                                                            width: "10rem",
                                                            height: "5rem",
                                                            objectFit: "fill",
                                                            borderRadius:
                                                                "5px",
                                                        }}
                                                        src={item.TemplateCategoryImage}
                                                        alt="Category-img"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.open(
                                                                item.TemplateCategoryImage,
                                                                "_blank"
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td>{item.TemplateCategoryName}</td>
                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {item.CreatedAt}
                                                    </Moment>
                                                </td>
                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {item.UpdatedAt}
                                                    </Moment>
                                                </td>
                                                <td>
                                                    {item.Status ===
                                                        1 ? (
                                                        <div
                                                            className={
                                                                CommonClasses[
                                                                "Status-active"
                                                                ]
                                                            }
                                                        >
                                                            <span>Active</span>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={
                                                                CommonClasses[
                                                                "Status-inactive"
                                                                ]
                                                            }
                                                        >
                                                            <span>
                                                                Inactive
                                                            </span>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <div
                                                        className={
                                                            CommonClasses[
                                                            "Action-btns"
                                                            ]
                                                        }
                                                    >
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate(
                                                                    `/edittemplatecategory/${item.TemplateCategoryId}`,
                                                                    {
                                                                        state: {
                                                                            templateCategory: item,
                                                                        },
                                                                    }
                                                                );
                                                            }}
                                                            style={{ marginRight: '8px' }}
                                                        >
                                                            <FaRegEdit />
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDelete(
                                                                    item.TemplateCategoryId,
                                                                    item.TemplateCategoryName
                                                                );
                                                            }}
                                                            style={{ 
                                                                color: '#dc3545',
                                                                backgroundColor: 'transparent',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No Template Categories Found</p>
                        </div>
                    )}
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className={CommonClasses["pagination"]}
                    />
                </div>
            </div>
        </Layout>
    );
}

export default TemplateCategories;
